define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

return declare(Controller, {
		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;
			var fd = this.m_formData;

			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("ColorColorways",fd.getFieldValue("ColorColorways"))
				.addParameter("Styles",fd.getFieldValue("Styles"))
				.addParameter("CreateColorway",fd.getFieldValue("CreateColorway"))
				.addParameter("UpdateColorwayName",fd.getFieldValue("UpdateColorwayName"))
				.addParameter("UpdateAttributes",fd.getFieldValue("UpdateAttributes"))
				.addParameter("AddToBOM",fd.getFieldValue("AddToBOMs"))
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});